import * as german from './de.json';
import * as english from './en.json';
import * as spanish from './es.json';
import * as french from './fr.json';
import * as japanese from './ja.json';
import * as korean from './ko.json';
import * as portuguese from './pt.json';
import * as arabic from './ar.json';


export default function (ngModule) {
  ngModule.constant('i18nDe', german.default);
  ngModule.constant('i18nEn', english.default);
  ngModule.constant('i18nEs', spanish.default);
  ngModule.constant('i18nFr', french.default);
  ngModule.constant('i18nJa', japanese.default);
  ngModule.constant('i18nKo', korean.default);
  ngModule.constant('i18nPt', portuguese.default);
  ngModule.constant('i18nAr', arabic.default);
}
